// Student
// Manager
import virtualClassroomManagerEventCreatorLocale from 'modules/virtualClassrooms/manager/EventCreator/localization/en.json'
import virtualClassroomManagerEventDetailsLocale from 'modules/virtualClassrooms/manager/EventDetails/localization/en.json'
import virtualClassroomManagerEventListLocale from 'modules/virtualClassrooms/manager/EventList/localization/en.json'
import virtualClassroomManagerSchedulesLocale from 'modules/virtualClassrooms/manager/Schedules/localization/en.json'
import virtualClassroomStudentEventDetailsLocale from 'modules/virtualClassrooms/student/EventDetails/localization/en.json'
import virtualClassroomStudentEventsLocale from 'modules/virtualClassrooms/student/Events/localization/en.json'
import virtualClassroomStudentParticipantScheduleDetailsLocale from 'modules/virtualClassrooms/student/ParticipantScheduleDetails/localization/en.json'
import virtualClassroomStudentPresenterScheduleDetailsLocale from 'modules/virtualClassrooms/student/PresenterScheduleDetails/localization/en.json'

const en = {
  student: {
    events: virtualClassroomStudentEventsLocale,
    eventDetails: virtualClassroomStudentEventDetailsLocale,
    participantScheduleDetails: virtualClassroomStudentParticipantScheduleDetailsLocale,
    presenterScheduleDetails: virtualClassroomStudentPresenterScheduleDetailsLocale,
  },
  manager: {
    eventCreator: virtualClassroomManagerEventCreatorLocale,
    eventDetails: virtualClassroomManagerEventDetailsLocale,
    eventList: virtualClassroomManagerEventListLocale,
    schedules: virtualClassroomManagerSchedulesLocale,
  },
}

export default en
